import { storeToRefs } from "pinia";
import { useLanguageStore } from "../stores/languageStore";

export function useTranslations() {
  const languageStore = useLanguageStore();
  const { translations } = storeToRefs(languageStore);
  return translations;
}
